import requests from "./httpService";

const ClientService = {
     getAllClient: async () =>{
        return requests.get("/client/all");
     },
     getClientById: async (id, body) =>{
        return requests.get(`/client/${id}`, body);
     },
     UpdateClientById: async (id, body) =>{
        return requests.put(`/client/${id}`, body);
     },
     addClient: async (body) =>{
        return requests.post("/client/add", body);
     },
     deleteClientById: async (id) =>{
        return requests.delete(`/client/${id}`);
     }
}

export default ClientService;